module.exports = __webpack_public_path__ + "img/img-57.c37d54be.png";